import config from '@/services/config'
import axios from './axios_interceptors'
import { tokenExpired, getUserData} from '@/auth/utils'

export default {
  getResults (datos) {
    return axios.post(`${config.urlPhp}/api/v1/buscador/influencers`, datos, {
      headers: {
        'brandme-key': process.env.VUE_APP_BRANDME_KEY,
      }
    })
      .then(response => response.data)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  freeSearcher(datos) {
    return axios.post(`${config.urlPhp}/api/v2/buscador/gratis`, datos, {
      headers: {
        'brandme-key': process.env.VUE_APP_BRANDME_KEY,
      }
    })
      .then(response => response.data)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  freeLookalikeSearcher(datos) {
    return axios.post(`${config.urlPhp}/api/v2/lookalike`, datos, {
      headers: {
        'brandme-key': process.env.VUE_APP_BRANDME_KEY,
      }
    })
      .then(response => response.data)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  
  getResultsYouTubeInternal(datos) {
    const { page, ...body } = datos
    const params = { size_page: 100, ...(page !== undefined ? { page } : {}) }
    return axios.post(`${config.urlCore}/api/v4/youtube/channels/search/`, body, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      params
    })
      .then(response => response.data)
      .catch(error => {
        if (error.response && error.response.status === 401) tokenExpired()
        return error.response
      })
  },

  getYouTubeTopicCategories() {
    return axios.get(`${config.urlCore}/api/v4/youtube/channels/topic-categories/`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
      .then(response => response.data.response || response.data)
      .catch(() => [])
  },

  getYouTubeInterestLabels(interest_type) {
    return axios.get(`${config.urlCore}/api/v4/youtube/channels/interest-labels/`, {
      params: { interest_type },
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
      .then(response => response.data.response || response.data)
      .catch(() => [])
  },

  getHistorySearches(data, page = 1, size_page = 10) {
    return axios.post(`${config.urlCore}/api/v3/searcher/history/?page=${page}&size_page=${size_page}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  getMainLocations() {
    return axios.get(`${config.urlCore}/api/v3/searcher/main-locations/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  toggleFavoriteSearch(searcher_uuid) {
    return axios.get(`${config.urlCore}/api/v3/searcher/toggle-favorite/${searcher_uuid}/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  deleteHistorySearch(searcher_uuid) {
    return axios.get(`${config.urlCore}/api/v3/searcher/history-delete/${searcher_uuid}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    })
      .then(response => response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  toggleFavoriteHistorySearch(searcher_uuid) {
    return axios.get(`${config.urlCore}/api/v3/searcher/toggle-favorite/${searcher_uuid}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    })
      .then(response => response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  changeTitleHistory(searcher_uuid, data) {
    return axios.post(`${config.urlCore}/api/v3/searcher/change-title/${searcher_uuid}/`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  saveLogSearch (datos) {
    return axios.post(`${config.urlCore}/api/v1/finder/log/search/`, datos, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    })
      .then(response => response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  getFirstPage (datos) {
    return axios.post(`${config.urlCore}/api/v1/finder/searcher/`, datos, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  analize (name, net = '') {
    const url = `${config.urlCore}/api/v1/finder/suggester/`
    return axios.post(url,
      {
        query: name,
        networks: net
      },
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })

  },
  getLocation (loc) {
    return axios.get(`${config.urlBase}/search-location`,
      {
        params:{
          query: loc
        }
      })
      .then(response => response.data.data)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  getCategories(network) {
    return axios.get(`${config.urlCore}/api/v1/finder/get/taxonomy/${network}/`,
      {
        headers: getUserData() ? { Authorization: `Bearer ${localStorage.getItem('accessToken')}`} : {}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  unlockReport(data) {
    return axios.post(`${config.urlCore}/api/v3/profile/report/unlock/`,
      data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      });
  }
}

export const getCategories = (network) => {
  return axios.get(`${config.urlCore}/api/v1/finder/get/taxonomy/${network}/`,
    {
      headers: getUserData() ? { Authorization: `Bearer ${localStorage.getItem('accessToken')}`} : {}
    }).then(response => response.data.response)
    .catch(error => {
      if (error.response.status === 401) tokenExpired()
      return error.response
    })
}
export const getMainInfluencers = (country) => {
  const url = `${config.urlPhp}/api/v2/main/influencers`
  return axios.post(url,
    {
      country
    }, {
      headers: {
        'brandme-key': process.env.VUE_APP_BRANDME_KEY,
      }
    })
    .then(response => response.data.data)
    .catch(error => {
      if (error.response.status === 401) tokenExpired()
      return error.response
    })
}

export const getSummaryInfluencer = (network, username) => {
  // let url = '';
  // if (network === 'tiktok' || network === 'youtube') url = `${config.urlLaravel}/api/v2/vpn-summary-influencer/`
  // else url = `${config.urlPhp}/api/v2/summary-influencer/`
  const url = `${config.urlPhp}/api/v2/summary-influencer/`
  return axios.post(url,
    { network, username },
    {
      headers: {
        'brandme-key': process.env.VUE_APP_BRANDME_KEY,
      }
    })
    .then(response => response.data.data)
    .catch(error => {
      if (error.response.status === 401) tokenExpired()
      return error.response
    })
}
export const getSummaryInfluencerTiktok = (network, username) => {
  // const url = `${config.urlLaravel}/api/v2/vpn-summary-influencer/`;
  const url = `${config.urlPhp}/api/v2/summary-influencer/`;

  return axios.post(
    url,
    { network, username },
    {
      headers: {
        'brandme-key': process.env.VUE_APP_BRANDME_KEY,
      }
    }
  )
    .then(response => response.data.data)
    .catch(error => {
      console.error("Error en la petición:", error);
      return error.response;
    });
};

export const getYouTubePrivateMetrics = (channel) => {
  return axios.get(
    `${config.urlCore}/api/v4/youtube/channel/${channel}/private-metrics/`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
  )
    .then(response => response.data.response)
    .catch(error => {
      if (error.response?.status === 401) tokenExpired();
      return null;
    });
};

export const getYouTubePublicProfile = (channel) => {
  return axios.get(
    `${config.urlCore}/api/v4/youtube/channel/${channel}/`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
  )
    .then(response => response.data.response)
    .catch(error => {
      if (error.response?.status === 401) tokenExpired();
      return error.response;
    });
};

export const getHistorySuscribersTiktok = (network, username) => {
  const url = `${config.urlPhp}/api/v2/vpn-history/`;

  return axios.post(
    url,
    { network, username },
    {
      headers: {
        'brandme-key': process.env.VUE_APP_BRANDME_KEY,
      }
    }
  )
    .then(response => response.data.data)
    .catch(error => {
      console.error("Error en la petición:", error);
      return error.response;
    });
};


export const getHistorySuscribers = (data) => {
  const url = `${config.urlPhp}/api/v2/history/${data.network}/${data.username}`
  return axios.get(url,
    {
      headers: {
        'brandme-key': process.env.VUE_APP_BRANDME_KEY,
      }
    })
    .then(response => response.data.data)
    .catch(error => {
      if (error.response.status === 401) tokenExpired()
      return error.response
    })
}


export const getHistorySuscribersLaravel = (data) => {
  return axios.post(`${config.urlPhp}/api/v2/vpn-history`, data,
    {
      headers: {
        'brandme-key': process.env.VUE_APP_BRANDME_KEY,
      }
    })
    .then(response => response.data.data)
    .catch(error => {
      if (error.response.status === 401) tokenExpired()
      return error.response
    })
}

export const getInfluencerIn = (username, network, objecttype) => {
  return axios.get(`${config.urlCore}/api/v1/finder/searcher/influencer-in/${username}/${network}/${objecttype}/`,
    {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
    .catch(error => {
      if (error.response.status === 401) tokenExpired()
      return error.response
    });
}

export const addFavoritesInlfuencer = (data) => {
  return axios.post(`${config.urlCore}/api/v3/lists/add-favorites/`,
    data,
    {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
    .catch(error => {
      if (error.response.status === 401) tokenExpired()
      return error.response
    });
}

export const unlockReport = (data) => {
  return axios.post(`${config.urlCore}/api/v3/profile/report/unlock/`,
    data,
    {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
    .catch(error => {
      if (error.response.status === 401) tokenExpired()
      return error.response
    });
}